export default __webpack_public_path__ + "static/media/finance.e6d2f3cb.png";